export const SEARCH_ROUTE = '/search';
